import { http } from "../../config/HttpMethod";
import { GetDocumentProjectsPayload } from "../../store/model/documents/documents";
import { ESP_ENDPOINTS } from "../calculations/endpoints";

export const GetMyDocumentProjects = async (payload: GetDocumentProjectsPayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.GET_MY_DOCUMENTS_PROJECTS}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const GetOtherDocumentProjects = async (payload: GetDocumentProjectsPayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.GET_OTHER_DOCUMENTS_PROJECTS}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
}